import { FC, useRef } from 'react';
import useGetRefSize from '../../../../hooks/useGetRefSize';
import LocalAccountsTable from './LocalAccountsTable';
import LocalAccountsToolbar from './components/LocalAccountsToolbar/LocalAccountsToolbar';
import { LocalAccountsProvider } from '../../context/LocalAccountsContext';
import useGetLocalAccountsInsights from '../../api/queries/useGetLocalAccountsInsights';
import LocalAccountsInsights from './LocalAccountsInsights';

const LocalAccounts: FC = () => {
    const tableContainerRef = useRef<HTMLDivElement | null>(null);
    const { height: tableHeight } = useGetRefSize(tableContainerRef);
    const { localAccountsInsights, loading: isLocalAccountsInsightsLoading } = useGetLocalAccountsInsights();

    return (
        <div className="flex-1 px-6 pt-4 h-full flex flex-col gap-4 overflow-x-hidden">
            <LocalAccountsInsights
                localAccountsInsights={localAccountsInsights}
                isLoading={isLocalAccountsInsightsLoading}
            />
            <LocalAccountsProvider>
                <div className="w-full flex flex-col gap-6">
                    <LocalAccountsToolbar />
                </div>
                <div ref={tableContainerRef} className="flex flex-1 overflow-hidden">
                    <LocalAccountsTable height={tableHeight} />
                </div>
                {/* Bulk actions can be added here if needed, similar to AdUsers */}
            </LocalAccountsProvider>
        </div>
    );
};

export default LocalAccounts;
